var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.900391,
    y: 0.775589,
    width: 50.4863,
    height: 50.4863,
    rx: 8.07781,
    fill: "#FD7401"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2116 23.9993H34.2213C34.4891 23.9993 34.7459 24.1057 34.9353 24.295C35.1246 24.4844 35.231 24.7412 35.231 25.009V35.1063C35.231 35.3741 35.1246 35.6309 34.9353 35.8202C34.7459 36.0096 34.4891 36.116 34.2213 36.116H18.0657C17.7979 36.116 17.541 36.0096 17.3517 35.8202C17.1623 35.6309 17.0559 35.3741 17.0559 35.1063V25.009C17.0559 24.7412 17.1623 24.4844 17.3517 24.295C17.541 24.1057 17.7979 23.9993 18.0657 23.9993H19.0754V22.9895C19.0754 22.0614 19.2582 21.1422 19.6134 20.2847C19.9686 19.4272 20.4893 18.648 21.1456 17.9917C21.8019 17.3353 22.5811 16.8147 23.4386 16.4595C24.2962 16.1043 25.2153 15.9215 26.1435 15.9215C27.0717 15.9215 27.9908 16.1043 28.8483 16.4595C29.7059 16.8147 30.485 17.3353 31.1414 17.9917C31.7977 18.648 32.3183 19.4272 32.6735 20.2847C33.0287 21.1422 33.2116 22.0614 33.2116 22.9895V23.9993ZM19.0754 26.0187V34.0965H33.2116V26.0187H19.0754ZM25.1337 28.0382H27.1532V32.0771H25.1337V28.0382ZM31.1921 23.9993V22.9895C31.1921 21.6506 30.6602 20.3664 29.7134 19.4196C28.7666 18.4728 27.4825 17.9409 26.1435 17.9409C24.8045 17.9409 23.5204 18.4728 22.5736 19.4196C21.6268 20.3664 21.0948 21.6506 21.0948 22.9895V23.9993H31.1921Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.2334,
    height: 24.2334,
    fill: "white",
    transform: "translate(14.0269 13.902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.16ad708c7e5691df826add0c748d284d.svg";
export { ForwardRef as ReactComponent };